import * as t from 'io-ts';

import {makeDefaultValueType} from './apiTypes';

/*
 * Runtime type.
 */

enum CalendarTypesEnum {
  GOOGLE = 'google',
  OFFICE365 = 'office365',
}

const RCalendarBehaviorsDirty = t.readonly(
  t.type({
    supportsAttendeesCanModify: makeDefaultValueType(t.boolean, true),
    supportsAttendeesCanInviteOthers: makeDefaultValueType(t.boolean, true),
    writerCanEditPrivateEvents: makeDefaultValueType(t.boolean, true),
  }),
);

/*
 * Type.
 */

export interface CalendarBehaviorsModel extends t.TypeOf<typeof RCalendarBehaviorsDirty> {}
export const RCalendarBehaviors = t.clean<CalendarBehaviorsModel>(RCalendarBehaviorsDirty as any);

/*
 * IO methods.
 */

export function parseCalendarBehaviors(src: any): CalendarBehaviorsModel {
  if (!src.properties) {
    return {} as CalendarBehaviorsModel;
  }

  return {
    supportsAttendeesCanModify: src.properties.supports_attendees_can_modify,
    supportsAttendeesCanInviteOthers: src.properties.supports_attendees_can_invite_others,
    writerCanEditPrivateEvents: src.provider !== CalendarTypesEnum.OFFICE365,
  };
}
